import type { RuleDefinition, RuleFinding } from '../domain/types';
import { getCellText } from '../domain/cells';
import { normalizeTextForComparison, normalizeUnit, normalizeUnitWriting } from '../utils/text';
import { finding, groupRows } from './helpers';

export const BQ012: RuleDefinition = {
  id: 'BQ012',
  name: '单位写法不统一',
  description: '在同一工作表内，对名称和特征相同的明细识别同义单位的不同写法。',
  defaultSeverity: 'info',
  enabled: true,
  applicableFields: ['unit'],
  message: '同一工作表内存在语义相同但写法不同的计量单位。',
  suggestion: '请按项目约定统一单位写法；本工具不会自动改写原清单。',
  check: ({ detailRows }) => {
    const results: RuleFinding[] = [];
    const groups = groupRows(detailRows, (row) => {
      const name = normalizeTextForComparison(getCellText(row, 'name'));
      const description = normalizeTextForComparison(getCellText(row, 'description'));
      const unit = normalizeUnit(getCellText(row, 'unit'));
      if (name.length === 0 || description.length === 0 || unit.length === 0) return '';
      return `${name}\u001f${description}\u001f${unit}`;
    });
    groups.forEach((rows) => {
      const firstByWriting = new Map<string, number>();
      [...rows]
        .sort((left, right) => left.excelRow - right.excelRow)
        .forEach((row) => {
          const writing = normalizeUnitWriting(getCellText(row, 'unit'));
          if (writing.length === 0 || firstByWriting.has(writing)) return;
          const relatedRows = [...firstByWriting.values()];
          firstByWriting.set(writing, row.excelRow);
          if (relatedRows.length === 0) return;
          results.push(
            finding(row, 'unit', {
              currentValue: getCellText(row, 'unit'),
              relatedRows,
              message: `该单位与第 ${relatedRows.join('、')} 行含义相同，但写法不一致。`,
            }),
          );
        });
    });
    return results;
  },
};
